import * as types from '../../action-types';
import { updateBankDetails as initialState } from "../../initialState";

const updateBankDetails = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_BANK_DETAILS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_BANK_DETAILS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_BANK_DETAILS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateBankDetails;
